module.exports = __webpack_public_path__ + "static/media/beauty-hygeine.0fad7367.jpg";